export const showLoader = () => {
    try {
        const loader = document.getElementsByClassName('Loader__background')[0];
        setTimeout(() => (loader.className = 'Loader__background show'));
    } catch {
        console.warn('Loader not found');
    }
};

export const hideLoader = () => {
    try {
        const loader = document.getElementsByClassName('Loader__background')[0];
        setTimeout(() => (loader.className = 'Loader__background hide'));
    } catch {
        console.warn('Loader not found');
    }
};
